import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const QA_NAME_FILTER_REPLACEMENT_MODAL = 'filterReplacement'

export const FILTER_REPLACEMENT_TEMPLATE_FIELD = 'filterTemplate'

export const INITIAL_VALUES = {
  [FILTER_REPLACEMENT_TEMPLATE_FIELD]: FORMIK_EMPTY_VALUE,
}
